import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImportMatchingContainerComponent } from './components/import-matching-container/import-matching-container.component';

const routes: Routes = [
  {
    path: '',
    component:ImportMatchingContainerComponent,
  
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImportMatchingRoutingModule { }
